import ChatBubbleStem from './chat-bubble-stem'
import LoadingDots from './loading-dots'

export default function LoadingBubble() {
  return (
    <div className="relative bg-secondary-100 rounded-full w-16 px-12 py-5">
      <LoadingDots size="md" />
      <div className="absolute bottom-0 left-[-8px] w-[18px] h-[23px] text-secondary-100">
        <ChatBubbleStem reverse />
      </div>
    </div>
  )
}
